import React from 'react';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';

const Breadcrumbs = ({ items, totalProducts }) => (
  <div className="breadcrumbs">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell xsmall-16">
          {Array.isArray(items) && items.map(({ link, label }, i) => {
            if (items.length - 1 === i) {
              return (
                <span className="breadcrumbs__item" key={uuid()}>{label.replace(/<[^>]*>?/gm, '')} {totalProducts && `(${totalProducts})`}</span>
              );
            }

            return <a className="breadcrumbs__item" key={uuid()} href={link}>{label.replace(/<[^>]*>?/gm, '')}</a>;
          })}
        </div>
      </div>
    </div>
  </div>
);

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  totalProducts: PropTypes.number,
};

export default Breadcrumbs;
